import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { specials } from "@/mocks/specials";

export default function SpecialEntry() {
  return (
    <section className="mx-auto mt-20 max-w-[1280px] px-4 md:px-6">
      <SectionHeading
        eyebrow="推荐专题"
        title="聚合重磅赛事合集"
        description="以专题形式串联同一主题下的多场赛事，帮助你系统追踪赛事脉络与焦点内容。"
      />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        {specials.map((topic, index) => (
          <Link
            key={topic.id}
            to={`/special?topic=${topic.id}`}
            className={`group relative flex flex-col justify-end overflow-hidden rounded-lg ${
              index === 0 ? "lg:col-span-2 lg:row-span-1" : ""
            }`}
          >
            <div className={`relative w-full overflow-hidden ${index === 0 ? "h-72" : "h-56"}`}>
              <img
                src={topic.cover}
                alt={`${topic.title} 专题封面`}
                title={`${topic.title} 赛事专题`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent"></div>
            </div>
            <div className="absolute inset-x-0 bottom-0 p-6">
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950">
                <i className="ri-bookmark-3-line"></i>
                {topic.eventIds.length} 场赛事
              </span>
              <h3 className="mt-3 font-heading text-lg font-bold text-background-50 md:text-xl">
                {topic.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm text-background-200">{topic.intro}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-accent-400">
                进入专题
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}